import { theme } from 'aimo-ui';
import Sheet from 'components/sheets/Sheet';
import useOngoingParkingSession from 'hooks/useOngoingParkingSession';
import React, { useState } from 'react';
import { useChargingStore } from 'stores/chargingStore';
import { useParkingStore } from 'stores/parkingStore';
import { isWeb } from 'utils/deviceUtils';
import { mobileSubSheetMinHeight } from 'utils/ongoingSessionUtils';
import OngoingParkingSession from './OngoingParkingSession';
import OngoingParkingZoneDetails from './OngoingParkingZoneDetails';

const snappingPointsExtra = isWeb ? [360] : [mobileSubSheetMinHeight];
const snappingPointsCollapsed = isWeb ? [0] : [1, 1, 1];
const bottomInset = 40;

export const OngoingParkingSheet: React.FC = () => {
  const ongoingChargingSessionId = useChargingStore(
    (state) => state.ongoingChargingSession
  );
  const ongoingParkingSheetExp =
    useParkingStore((state) => state.selectedOngoingSession) === 'PARKING';
  const [showExtendParking, setShowExtendParking] = useState(false);
  const { ongoingParkingSession, parkingZoneResult } =
    useOngoingParkingSession();
  const parkingZoneUid: string = ongoingParkingSession?.parkingZoneUid || '';

  const { info, locationType, countryCode, parkingMethods } =
    parkingZoneResult?.data?.parkZone ?? {};
  const getParkingZoneDetailsSheetSnappingPoints = () => {
    return showExtendParking ? snappingPointsCollapsed : snappingPointsExtra;
  };

  if (!ongoingParkingSession) {
    return <></>;
  }
  const seStreetZone = locationType === 'STREET' && countryCode === 'SE';
  const hasAdditionalServices =
    locationType !== 'STREET' ||
    seStreetZone ||
    info?.bravidaDoorCode ||
    info?.doorCode ||
    (parkingMethods?.evCharging &&
      ongoingParkingSheetExp &&
      !ongoingChargingSessionId);
  return (
    <>
      <OngoingParkingSession
        sheetExpanded={ongoingParkingSheetExp}
        session={ongoingParkingSession}
        showExtendParking={showExtendParking}
        setShowExtendParking={setShowExtendParking}
      />
      {!showExtendParking && hasAdditionalServices && (
        <Sheet
          snappingPoints={[...getParkingZoneDetailsSheetSnappingPoints()]}
          isDynamicSheet
          bottom
          left={0}
          borderRadius={theme.borderRadius.ongoingSheet}
          bottomInset={bottomInset}
          sheetMinHeight={30}
          sheetMaxHeight={400}
          webSheetOpenDefault={false}>
          <OngoingParkingZoneDetails
            parkingZoneUid={parkingZoneUid}
            licensePlate={ongoingParkingSession.accessDevice?.value}
          />
        </Sheet>
      )}
    </>
  );
};

export default OngoingParkingSheet;
